<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="3">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker locale="vi" id="datepicker" v-model="dateRange" :model-config="dateRangeConfig" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol sm="3" xs="12">
        <BaseSelect
          :options="sourceTypeSelect.options"
          :data="sourceTypeSelect.data"
          ref="sourceTypeSelect"
        ></BaseSelect>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseSelect :options="departmentsInput.options" :data="departmentsInput.data"
                    ref="departmentsInput"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #description="{ item }">
            <td>
              <span class="description" :key="item.id" v-c-tooltip.hover="item.description">{{ item.description }}</span>
            </td>
          </template>
          <template #level="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.level == 0">Bình thường</span>
              <span class="badge badge-warning" v-else-if="item.level == 1">Ưu tiên</span>
              <span class="badge badge-danger" v-else-if="item.level == 2">Khẩn cấp</span>
            </td>
          </template>
          <template #sourceType="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.sourceType == 1">Biên tập</span>
              <span class="badge badge-light" v-else-if="item.sourceType == 2">Chuyển đổi văn bản</span>
              <span class="badge badge-light" v-else-if="item.sourceType == 3">Ghép tệp tin</span>
              <span class="badge badge-light" v-else-if="item.sourceType == 4">Ghi âm tệp tin</span>
            </td>
          </template>
          <template #fileTypeName="{ item }">
            <td>
              <span class="badge badge-light">{{ item.fileTypeName }}</span>
            </td>
          </template>
          <template #url="{ item }">
            <td>
              <span class="view-file" v-if="item.url" @click="viewFile(item.url)">Ấn vào để xem tệp</span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Tải xuống'"
                  square
                  size="sm"
                  @click="downloadFile(item.url)"><i class="fa fa-download"></i>
                </CButton>
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Gửi tới đài'"
                  square
                  size="sm"
                  @click="sendToStation(item)"><i class="fa fa-send"></i>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.title)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";

export default {
  name: "AudioFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/audio-file/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "bản tin",
          that.actionData.model.fileName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.fileId,
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa bản tin " + that.actionData.model.fileName + " thành công"});
        that.loadDataMainTable();
      }
    });

    return {
      loading: {value: false},
      loadingShareFile: {value: false},
      isShowPopupShareFile: false,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      sourceTypeSelect: {
        options: {
          filter: false,
          label: "Nguồn bản tin",
        },
        data: {
          name: "sourceType",
          items: [
            {key: "null", value: "Tất cả nguồn bản tin"},
            {key: "1", value: "Bản tin biên tập"},
            {key: "2", value: "Chuyển đổi văn bản"},
            {key: "3", value: "Ghép tệp tin"},
            {key: "4", value: "Ghi âm tệp tin"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      departmentsInput: {
        options: {
          filter: true,
          label: "Lĩnh vực",
          selectAllText: "Tất cả lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%"},
            {key: "title", label: "Tiêu đề"},
            {key: "description", label: "Mô tả"},
            {key: "fileTypeName", label: "Lĩnh vực"},
            {key: "sourceType", label: "Nguồn bản tin"},
            {key: "duration", label: "Thời lượng"},
            {key: "level", label: "Cấp độ"},
            {key: "url", label: "Tệp"},
            {key: "action", label: "Thao tác"},
          ],
          slots: [
            "index",
            "createDate",
            "action",
            "level",
            "url",
            "sourceType",
            "fileTypeName",
            "description"
          ],
          pageSize: 15
        },
        dataSource: {
          url: "/audio-file/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start);
            params.toDate = that.$helper.formatDate(that.dateRange.end);
            return params;
          },
          response(dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    async viewFile(url) {
      // let that = this;
      // this.loading.value = true;
      // const data = await this.$helper.blobFileByUrl(url);
      // setTimeout(() => {
      //   that.loading.value = false;
      //   window.open(data);
      // }, 500);
      window.open(this.$helper.viewFileByUrl(url));
    },
    async downloadFile(url) {
      this.loading.value = true;
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      a.click();
    },
    sendToStation: function (item) {
      let that = this;
      that.$router.push({
        path: "/audio-editor/send-to-station.html",
        query: {fileId: item.id},
      });
    },
    loadDataDepartment: function () {
      let that = this;
      this.$helper.loadDataSource({
        url: "/common/listField",
        successCallback: function (response) {
          that.departmentsInput.data.items = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
      let actionData = this.actionData.model;
      actionData.fileId = fileId || null;
      actionData.fileName = fileName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
    this.loadDataDepartment();
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}
</style>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
